import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "layout-image-above-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 3a2.75 2.75 0 0 1 2.75 2.75v5A2.75 2.75 0 0 1 17 13.5H7a2.75 2.75 0 0 1-2.75-2.75v-5A2.75 2.75 0 0 1 7 3h10Zm1.25 2.75c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v5c0 .7.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-5Z"
    }, null, -1),
    _createElementVNode("path", { d: "M4.25 21.25c0-.41.34-.75.75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75ZM5 16.03a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H5Z" }, null, -1)
  ])))
}
export default { render: render }